(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8160,4006,4266],{

/***/ 9052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Categories; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(29);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(7794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(1608);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(1555);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 94 modules
var swiper_esm = __webpack_require__(8116);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(719);
// EXTERNAL MODULE: ./src/components/Home/Categories/index.module.scss
var index_module = __webpack_require__(6063);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./src/assets/images/svg/arrow-big.svg
var arrow_big = __webpack_require__(9492);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./src/components/handlers/index.js + 1 modules
var handlers = __webpack_require__(9400);
// EXTERNAL MODULE: ./node_modules/react-pdf/dist/esm/Page/TextLayer.css
var TextLayer = __webpack_require__(4324);
// EXTERNAL MODULE: ./node_modules/react-pdf/dist/esm/Page/AnnotationLayer.css
var AnnotationLayer = __webpack_require__(1362);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-pdf/dist/esm/pdfjs.js
var pdfjs = __webpack_require__(7042);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 5 modules
var toConsumableArray = __webpack_require__(6687);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(4012);
// EXTERNAL MODULE: ./node_modules/react-range/lib/index.js
var lib = __webpack_require__(4398);
;// CONCATENATED MODULE: ./src/components/Home/Categories/assets/arrow.svg
/* harmony default export */ var arrow = ({"src":"/_next/static/media/arrow.03744073.svg","height":24,"width":24});
;// CONCATENATED MODULE: ./src/components/Home/Categories/assets/filter.svg
/* harmony default export */ var filter = ({"src":"/_next/static/media/filter.3cec0aee.svg","height":800,"width":800});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/components/Home/Categories/filters.js



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable react-hooks/exhaustive-deps */









var filterTimeout = null;

function Filters(_ref) {
  var _ref2;

  var data = _ref.data,
      rawData = _ref.rawData,
      setData = _ref.setData;

  var _useRouter = (0,router.useRouter)(),
      locale = _useRouter.locale;

  var ageMin = 18,
      ageMax = 100,
      experienceMin = 0,
      experienceMax = 40,
      salaryMin = 1,
      salaryMax = 9999,
      steps = 1;

  var _useState = (0,react.useState)([ageMin, ageMax]),
      ages = _useState[0],
      setAges = _useState[1];

  var _useState2 = (0,react.useState)([experienceMin, experienceMax]),
      experiences = _useState2[0],
      setExperiences = _useState2[1];

  var _useState3 = (0,react.useState)([salaryMin, salaryMax]),
      salaries = _useState3[0],
      setSalaries = _useState3[1];

  var _useState4 = (0,react.useState)(""),
      selectedCountry = _useState4[0],
      setSelectedCountry = _useState4[1];

  var _useState5 = (0,react.useState)(""),
      selectedReligion = _useState5[0],
      setSelectedReligion = _useState5[1];

  (0,react.useEffect)(function () {
    if (selectedCountry || selectedReligion || ages !== null && ages !== void 0 && ages[0] || experiences !== null && experiences !== void 0 && experiences[0] || salaries !== null && salaries !== void 0 && salaries[0]) setData(rawData === null || rawData === void 0 ? void 0 : rawData.filter(function (item) {
      var _item$country, _item$country$name, _item$religion, _item$name, _item$name2;

      return (!selectedCountry || (item === null || item === void 0 ? void 0 : (_item$country = item.country) === null || _item$country === void 0 ? void 0 : (_item$country$name = _item$country.name) === null || _item$country$name === void 0 ? void 0 : _item$country$name[locale]) === selectedCountry) && (!selectedReligion || ((item === null || item === void 0 ? void 0 : (_item$religion = item.religion) === null || _item$religion === void 0 ? void 0 : _item$religion[locale]) || item.religion) === selectedReligion) && Number(item === null || item === void 0 ? void 0 : item.age) >= ages[0] && Number(item === null || item === void 0 ? void 0 : item.age) <= ages[1] && Number(item === null || item === void 0 ? void 0 : (_item$name = item.name) === null || _item$name === void 0 ? void 0 : _item$name.experienceYears) >= experiences[0] && Number(item === null || item === void 0 ? void 0 : (_item$name2 = item.name) === null || _item$name2 === void 0 ? void 0 : _item$name2.experienceYears) <= experiences[1] && Number(item === null || item === void 0 ? void 0 : item.salary) >= salaries[0] && Number(item === null || item === void 0 ? void 0 : item.salary) <= salaries[1];
    }));
  }, [JSON.stringify({
    ages: ages,
    data: data,
    rawData: rawData,
    experiences: experiences,
    locale: locale,
    selectedCountry: selectedCountry,
    selectedReligion: selectedReligion,
    setData: setData,
    salaries: salaries
  })]);
  var renderCountries = (_ref2 = (0,toConsumableArray/* default */.Z)(new Set(rawData === null || rawData === void 0 ? void 0 : rawData.map(function (item) {
    var _item$country2, _item$country2$name;

    return item === null || item === void 0 ? void 0 : (_item$country2 = item.country) === null || _item$country2 === void 0 ? void 0 : (_item$country2$name = _item$country2.name) === null || _item$country2$name === void 0 ? void 0 : _item$country2$name[locale];
  })))) === null || _ref2 === void 0 ? void 0 : _ref2.map(function (country, index) {
    var handleChange = function handleChange(e) {
      setSelectedCountry(e);
      var filterLabel = document.getElementById("filter-toggle");
      filterLabel.click();
    };

    if (!country) return;
    return /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
          type: "radio",
          name: "country",
          value: country,
          checked: selectedCountry === country,
          onChange: function onChange(e) {
            return handleChange(e.target.value);
          }
        }), country]
      })
    }, index);
  });
  var religions = [{
    ar: "الاسلام",
    en: "Islam"
  }, {
    ar: "المسيحية",
    en: "Christianity"
  }, {
    ar: "اليهودية",
    en: "Judaism"
  }];
  var renderReligions = religions === null || religions === void 0 ? void 0 : religions.map(function (rel, index) {
    var handleChange = function handleChange(e) {
      setSelectedReligion(e);
      var filterLabel = document.getElementById("filter-toggle");
      filterLabel.click();
    };

    return /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
          type: "radio",
          name: "religion.".concat(locale),
          checked: selectedReligion === rel.ar,
          value: rel.ar,
          onChange: function onChange(e) {
            return handleChange(e.target.value);
          }
        }), rel === null || rel === void 0 ? void 0 : rel[locale]]
      })
    }, index);
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "container text-center",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
        htmlFor: "filter-toggle",
        className: "text-black filtering",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: filter.src,
          alt: "",
          width: 30,
          height: 30,
          className: "filter-icon"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: arrow.src,
          alt: "",
          width: 30,
          height: 30,
          className: "arrow"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
          id: "filter"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
      type: "checkbox",
      id: "filter-toggle"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "filter container mb-5",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
        htmlFor: "filter-toggle",
        className: "w-100 btn-close"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "underdashed-title",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
            id: "countires"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            onClick: function onClick() {
              return setSelectedCountry("");
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
              id: "reset"
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "list",
          children: renderCountries
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "categories",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "underdashed-title",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
            id: "religions"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            onClick: function onClick() {
              return setSelectedReligion("");
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
              id: "reset"
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "list",
          children: renderReligions
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "price",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "underdashed-title",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
            id: "age"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            onClick: function onClick() {
              return setAges([ageMin, ageMax]);
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
              id: "reset"
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(lib.Range, {
          values: ages,
          step: steps,
          min: ageMin,
          max: ageMax,
          onChange: function onChange(values) {
            setAges(values);
          },
          renderTrack: function renderTrack(_ref3) {
            var props = _ref3.props,
                children = _ref3.children;
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              onMouseDown: props.onMouseDown,
              onTouchStart: props.onTouchStart,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                ref: props.ref,
                style: {
                  height: "5px",
                  // width: "100%",
                  borderRadius: "4px",
                  background: (0,lib.getTrackBackground)({
                    values: ages,
                    colors: ["#E7E7E7", "#d7aef0", "#E7E7E7"],
                    min: ageMin,
                    max: ageMax
                  }),
                  alignSelf: "center",
                  direction: "ltr"
                },
                children: children
              })
            });
          },
          renderThumb: function renderThumb(_ref4) {
            var props = _ref4.props,
                isDragged = _ref4.isDragged;
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", _objectSpread(_objectSpread({
              "aria-label": "range"
            }, props), {}, {
              className: "thumbs",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "thumb-info",
                children: ages === null || ages === void 0 ? void 0 : ages[props.key]
              })
            }));
          }
        }, "age"), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "info",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            children: [ages === null || ages === void 0 ? void 0 : ages[1], " ", /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
              id: "year"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            children: [ages === null || ages === void 0 ? void 0 : ages[0], " ", /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
              id: "year"
            })]
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "price",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "underdashed-title",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
            id: "experienceYears"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            onClick: function onClick() {
              return setExperiences([experienceMin, experienceMax]);
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
              id: "reset"
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(lib.Range, {
          values: experiences,
          step: steps,
          min: experienceMin,
          max: experienceMax,
          onChange: function onChange(values) {
            setExperiences(values);
          },
          renderTrack: function renderTrack(_ref5) {
            var props = _ref5.props,
                children = _ref5.children;
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              onMouseDown: props.onMouseDown,
              onTouchStart: props.onTouchStart,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                ref: props.ref,
                style: {
                  height: "5px",
                  // width: "100%",
                  borderRadius: "4px",
                  background: (0,lib.getTrackBackground)({
                    values: experiences,
                    colors: ["#E7E7E7", "#d7aef0", "#E7E7E7"],
                    min: experienceMin,
                    max: experienceMax
                  }),
                  alignSelf: "center",
                  direction: "ltr"
                },
                children: children
              })
            });
          },
          renderThumb: function renderThumb(_ref6) {
            var props = _ref6.props,
                isDragged = _ref6.isDragged;
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", _objectSpread(_objectSpread({
              "aria-label": "range"
            }, props), {}, {
              className: "thumbs",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "thumb-info",
                children: experiences === null || experiences === void 0 ? void 0 : experiences[props.key]
              })
            }));
          }
        }, "experienceYears"), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "info",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            children: [experiences === null || experiences === void 0 ? void 0 : experiences[1], " ", /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
              id: "year"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            children: [experiences === null || experiences === void 0 ? void 0 : experiences[0], " ", /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
              id: "year"
            })]
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "price",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "underdashed-title",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
            id: "salary"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            onClick: function onClick() {
              return setSalaries([salaryMin, salaryMax]);
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
              id: "reset"
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(lib.Range, {
          values: salaries,
          step: steps,
          min: salaryMin,
          max: salaryMax,
          onChange: function onChange(values) {
            setSalaries(values);
          },
          renderTrack: function renderTrack(_ref7) {
            var props = _ref7.props,
                children = _ref7.children;
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              onMouseDown: props.onMouseDown,
              onTouchStart: props.onTouchStart,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                ref: props.ref,
                style: {
                  height: "5px",
                  // width: "100%",
                  borderRadius: "4px",
                  background: (0,lib.getTrackBackground)({
                    values: salaries,
                    colors: ["#E7E7E7", "#d7aef0", "#E7E7E7"],
                    min: salaryMin,
                    max: salaryMax
                  }),
                  alignSelf: "center",
                  direction: "ltr"
                },
                children: children
              })
            });
          },
          renderThumb: function renderThumb(_ref8) {
            var props = _ref8.props,
                isDragged = _ref8.isDragged;
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", _objectSpread(_objectSpread({
              "aria-label": "range"
            }, props), {}, {
              className: "thumbs",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "thumb-info",
                children: salaries === null || salaries === void 0 ? void 0 : salaries[props.key]
              })
            }));
          }
        }, "salary"), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "info d-block",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "text-end",
            children: [salaries === null || salaries === void 0 ? void 0 : salaries[1], " ", /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
              id: "r.s"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "text-end",
            children: [salaries === null || salaries === void 0 ? void 0 : salaries[0], " ", /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
              id: "r.s"
            })]
          })]
        })]
      })]
    })]
  });
}

/* harmony default export */ var filters = (/*#__PURE__*/(0,react.memo)(Filters));
// EXTERNAL MODULE: ./src/components/helpers/functions.js
var functions = __webpack_require__(7819);
// EXTERNAL MODULE: ./src/assets/images/svg/download.svg
var download = __webpack_require__(1476);
// EXTERNAL MODULE: ./src/assets/images/svg/expand.svg
var expand = __webpack_require__(7571);
// EXTERNAL MODULE: ./src/assets/images/svg/sar.svg
var sar = __webpack_require__(5175);
// EXTERNAL MODULE: ./src/components/Shared/RequestForm.js
var RequestForm = __webpack_require__(4266);
;// CONCATENATED MODULE: ./src/components/Home/Categories/index.js



function Categories_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Categories_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Categories_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Categories_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





 // import { FormattedDate, FormattedMessage } from "react-intl";






 // import { FormattedDate, FormattedMessage } from "react-intl";








 // import Lightbox from "../../Shared/Lightbox";








var FormattedMessage = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 3443).then(__webpack_require__.bind(__webpack_require__, 3443)).then(function (mod) {
    return mod.FormattedMessage;
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(3443)];
    }
  }
});
function Categories(_ref) {
  var _data$heading;

  var data = _ref.data,
      _ref$page = _ref.page,
      page = _ref$page === void 0 ? "" : _ref$page,
      _ref$filterSlug = _ref.filterSlug,
      filterSlug = _ref$filterSlug === void 0 ? "" : _ref$filterSlug,
      _ref$breakPoints = _ref.breakPoints,
      breakPoints = _ref$breakPoints === void 0 ? false : _ref$breakPoints,
      _ref$sliderProps = _ref.sliderProps,
      sliderProps = _ref$sliderProps === void 0 ? {} : _ref$sliderProps;

  var _useRouter = (0,router.useRouter)(),
      locale = _useRouter.locale,
      query = _useRouter.query;

  var dir = locale == "ar" ? "rtl" : "ltr";

  var _useState = (0,react.useState)({}),
      slideInfo = _useState[0],
      setSlideInfo = _useState[1];

  var _useState2 = (0,react.useState)(0),
      slideNum = _useState2[0],
      setSlideNum = _useState2[1];

  var _useState3 = (0,react.useState)(data),
      items = _useState3[0],
      setItems = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      displayPagination = _useState4[0],
      setDisplayPagination = _useState4[1];

  var _useState5 = (0,react.useState)([]),
      displayFilters = _useState5[0],
      setDisplayFilters = _useState5[1];

  var _useState6 = (0,react.useState)(0),
      pageNum = _useState6[0],
      setPageNum = _useState6[1];

  var _useState7 = (0,react.useState)(false),
      isPageLoading = _useState7[0],
      setIsPageLoading = _useState7[1];

  var _useState8 = (0,react.useState)(""),
      expandedImage = _useState8[0],
      setExpandedImage = _useState8[1];

  var _useState9 = (0,react.useState)(false),
      isRequestOpen = _useState9[0],
      setIsRequestOpen = _useState9[1];

  var _useState10 = (0,react.useState)(null),
      selectedPerson = _useState10[0],
      setSelectedPerson = _useState10[1];

  var handlePdfDownload = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(item) {
      var _item$name, _item$name2;

      var pdfUrl, response, blob, link;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              pdfUrl = item === null || item === void 0 ? void 0 : (_item$name = item.name) === null || _item$name === void 0 ? void 0 : _item$name.file;
              _context.next = 3;
              return fetch(pdfUrl);

            case 3:
              response = _context.sent;
              _context.next = 6;
              return response.blob();

            case 6:
              blob = _context.sent;
              link = document.createElement("a");
              link.href = window.URL.createObjectURL(blob);
              link.download = "".concat(item === null || item === void 0 ? void 0 : (_item$name2 = item.name) === null || _item$name2 === void 0 ? void 0 : _item$name2.ar, ".pdf");
              link.click();
              window.URL.revokeObjectURL(link.href);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handlePdfDownload(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleExpandImage = function handleExpandImage(item) {
    var _item$name3;

    var imageUrl = (0,functions/* handleImageLink */.Iz)(item === null || item === void 0 ? void 0 : (_item$name3 = item.name) === null || _item$name3 === void 0 ? void 0 : _item$name3.pdfImage);
    if (!imageUrl) return;
    setExpandedImage(imageUrl);
  };

  var handleOpenRequestModal = function handleOpenRequestModal(person) {
    setSelectedPerson(person);
    setIsRequestOpen(true);
  };

  var projectsTopRef = react.useRef(null);
  (0,react.useEffect)(function () {
    pdfjs/* default.GlobalWorkerOptions.workerSrc */.Z.GlobalWorkerOptions.workerSrc = "//unpkg.com/pdfjs-dist@".concat(pdfjs/* default.version */.Z.version, "/legacy/build/pdf.worker.min.js");
  }, []);
  (0,react.useEffect)(function () {
    var _data$items;

    var filtered = data === null || data === void 0 ? void 0 : (_data$items = data.items) === null || _data$items === void 0 ? void 0 : _data$items.filter(function (item) {
      var _item$country;

      return ((_item$country = item.country) === null || _item$country === void 0 ? void 0 : _item$country.id) === (query === null || query === void 0 ? void 0 : query.country);
    });
    setItems(filtered); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);
  (0,react.useEffect)(function () {
    setPageNum(0);
  }, [items]);
  var renderProjectItems = (0,react.useMemo)(function () {
    var _items$slice;

    return (items === null || items === void 0 ? void 0 : items.length) > 0 ? items === null || items === void 0 ? void 0 : (_items$slice = items.slice(pageNum * 9, (pageNum + 1) * 9)) === null || _items$slice === void 0 ? void 0 : _items$slice.map(function (item, k) {
      var _item$name4, _item$name5, _item$country2, _item$country2$name, _item$religion, _item$name6, _item$job;

      if (item !== null && item !== void 0 && item.available) return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "personnel",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "img",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: (0,functions/* handleImageLink */.Iz)(item === null || item === void 0 ? void 0 : (_item$name4 = item.name) === null || _item$name4 === void 0 ? void 0 : _item$name4.pdfImage),
              alt: "",
              width: 500,
              height: 500
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
              type: "button",
              className: "pdf-btn",
              onClick: function onClick() {
                return handlePdfDownload(item);
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                src: download/* default */.Z,
                alt: "",
                width: 16,
                height: 16
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedMessage, {
                id: "downloadPdf"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
              type: "button",
              className: "expand-btn",
              onClick: function onClick() {
                return handleExpandImage(item);
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                src: expand/* default */.Z,
                alt: "",
                width: 16,
                height: 16
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedMessage, {
                id: "expandImage"
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "info",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
              children: item === null || item === void 0 ? void 0 : (_item$name5 = item.name) === null || _item$name5 === void 0 ? void 0 : _item$name5[locale]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  className: "key",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormattedMessage, {
                    id: "nationality"
                  }), ":", " "]
                }), item === null || item === void 0 ? void 0 : (_item$country2 = item.country) === null || _item$country2 === void 0 ? void 0 : (_item$country2$name = _item$country2.name) === null || _item$country2$name === void 0 ? void 0 : _item$country2$name[locale]]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  className: "key",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormattedMessage, {
                    id: "code"
                  }), ":"]
                }), item === null || item === void 0 ? void 0 : item.id]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  className: "key",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormattedMessage, {
                    id: "religion"
                  }), ":", " "]
                }), item === null || item === void 0 ? void 0 : (_item$religion = item.religion) === null || _item$religion === void 0 ? void 0 : _item$religion[locale]]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  className: "key",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormattedMessage, {
                    id: "experienceYears"
                  }), ":", " "]
                }), item === null || item === void 0 ? void 0 : (_item$name6 = item.name) === null || _item$name6 === void 0 ? void 0 : _item$name6.experienceYears]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  className: "key",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormattedMessage, {
                    id: "age"
                  }), ":"]
                }), item === null || item === void 0 ? void 0 : item.age, " ", /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedMessage, {
                  id: "year"
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  className: "key",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormattedMessage, {
                    id: "job"
                  }), ":"]
                }), item === null || item === void 0 ? void 0 : (_item$job = item.job) === null || _item$job === void 0 ? void 0 : _item$job[locale]]
              }), (item === null || item === void 0 ? void 0 : item.salary) && /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  className: "key",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormattedMessage, {
                    id: "monthlySalary"
                  }), ":"]
                }), " ", item === null || item === void 0 ? void 0 : item.salary, /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                  src: sar/* default */.Z,
                  alt: "",
                  width: 18,
                  height: 18,
                  className: "mx-1"
                })]
              }), (item === null || item === void 0 ? void 0 : item.recruitmentFees) && /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  className: "key",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormattedMessage, {
                    id: "recruitmentFees"
                  }), ":"]
                }), " ", item === null || item === void 0 ? void 0 : item.recruitmentFees, /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                  src: sar/* default */.Z,
                  alt: "",
                  width: 18,
                  height: 18,
                  className: "mx-1"
                })]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "btns d-flex align-items-center justify-content-between gap-3",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                type: "button",
                className: "open-request-modal nw-btn",
                onClick: function onClick() {
                  return handleOpenRequestModal(item);
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedMessage, {
                  id: "recruitmentRequest"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: "/personnel/".concat(item === null || item === void 0 ? void 0 : item.id),
                legacyBehavior: true,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "details-link nw-btn",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedMessage, {
                    id: "viewDetails"
                  })
                })
              })]
            })]
          })]
        })
      }, "project" + k);
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "alert alert-warning",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedMessage, {
        id: "noDataFound"
      })
    });
  }, [items, pageNum, locale]);
  var itemsPerPage = 9;
  var totalPages = Math.ceil((items === null || items === void 0 ? void 0 : items.length) / itemsPerPage);

  var handlePageChange = function handlePageChange(newPage) {
    var _projectsTopRef$curre;

    setIsPageLoading(true);
    setPageNum(newPage);
    (_projectsTopRef$curre = projectsTopRef.current) === null || _projectsTopRef$curre === void 0 ? void 0 : _projectsTopRef$curre.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
    setTimeout(function () {
      setIsPageLoading(false);
    }, 300);
  };

  var slidingbuttons = totalPages > 1 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "custom-pagination wrapper",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "pagination-wrapper",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "swiper_button_next gradient-btn ".concat(pageNum + 1 >= totalPages ? "disable" : ""),
        onClick: function onClick() {
          return pageNum + 1 < totalPages && handlePageChange(pageNum + 1);
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), Categories_objectSpread(Categories_objectSpread({}, arrow_big/* default */.Z), {}, {
          alt: ""
        }))
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "row",
        children: Array.from({
          length: totalPages
        }).map(function (_, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "w-auto pagination-num ".concat(pageNum === index ? "text-decoration-underline" : ""),
            onClick: function onClick() {
              return handlePageChange(index);
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "cursor-pointer",
              children: index + 1
            })
          }, index);
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "swiper_button_prev gradient-btn ".concat(pageNum === 0 ? "disable" : ""),
        onClick: function onClick() {
          return pageNum > 0 && handlePageChange(pageNum - 1);
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), Categories_objectSpread(Categories_objectSpread({}, arrow_big/* default */.Z), {}, {
          alt: ""
        }))
      })]
    })
  });

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (index_module_default()).projects,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Row/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Col/* default */.Z, {
        children: [page != "categories" ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "wrapper",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Row/* default */.Z, {
              className: "justify-content-center justify-content-md-between inff",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "w-auto",
                children: [page != "id" ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "pb-1 ",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: "section-tag text-start",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedMessage, {
                      id: "categories"
                    })
                  })
                }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "pb-1 m-auto",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: "section-tag text-center",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedMessage, {
                        id: "other-projects"
                      })
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                    className: "unique-bold text-black",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedMessage, {
                      id: "more-projects"
                    })
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                  className: "unique-bold text-black",
                  children: (data === null || data === void 0 ? void 0 : (_data$heading = data.heading) === null || _data$heading === void 0 ? void 0 : _data$heading[locale]) || ""
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "w-auto show-projects-link align-self-end",
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)((link_default()), {
                  href: "/categories",
                  className: "btn w-auto",
                  "aria-label": "categories-link",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormattedMessage, {
                    id: "all-categories"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), Categories_objectSpread(Categories_objectSpread({}, arrow_big/* default */.Z), {}, {
                      alt: ""
                    }))
                  })]
                })
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Row/* default */.Z, {
            className: "swiperWrapper container-p-start w-100 m-0  ",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, Categories_objectSpread(Categories_objectSpread({
              onSlideChange: function onSlideChange(e) {
                setSlideInfo(e);
                setSlideNum(e === null || e === void 0 ? void 0 : e.activeIndex); // console.log("slideInfo", e);
              },
              runCallbacksOnInit: true,
              onInit: function onInit(e) {
                var _e$snapGrid;

                (e === null || e === void 0 ? void 0 : (_e$snapGrid = e.snapGrid) === null || _e$snapGrid === void 0 ? void 0 : _e$snapGrid.length) > 1 && setDisplayPagination(true);
              },
              dir: dir,
              effect: "fade",
              autoplay: {
                delay: 2500,
                disableOnInteraction: false
              },
              slidesPerView: 1,
              spaceBetween: 25,
              breakpoints: breakPoints ? breakPoints : {
                375: {
                  slidesPerView: 1
                },
                425: {
                  slidesPerView: 1.2
                },
                500: {
                  slidesPerView: 1.4
                },
                565: {
                  slidesPerView: 1.5
                },
                695: {
                  slidesPerView: 2
                },
                788: {
                  slidesPerView: 2.3
                },
                950: {
                  slidesPerView: 2.7
                },
                1140: {
                  slidesPerView: 3
                },
                1340: {
                  slidesPerView: 3.4
                },
                1494: {
                  slidesPerView: 3.7
                },
                1740: {
                  slidesPerView: 4.7
                },
                1940: {
                  slidesPerView: 5
                },
                2420: {
                  slidesPerView: 6.2
                }
              },
              navigation: {
                nextEl: ".swiper_button_next",
                prevEl: ".swiper_button_prev"
              },
              modules: [swiper_esm/* Navigation */.W_]
            }, sliderProps), {}, {
              children: renderProjectItems
            })), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "custom-pagination container-p-start ".concat(!displayPagination && "hidden"),
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "pagination-wrapper text-black",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "swiper_button_next gradient-btn",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), Categories_objectSpread(Categories_objectSpread({}, arrow_big/* default */.Z), {}, {
                    alt: ""
                  }))
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedMessage, {
                  id: "next"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "progress",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "progress-bar",
                    role: "progressbar",
                    style: {
                      width: "".concat((slideInfo === null || slideInfo === void 0 ? void 0 : slideInfo.progress) * 100, "%")
                    },
                    "aria-label": "Progress bar",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: "sr-only",
                      children: " "
                    })
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedMessage, {
                  id: "prev"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "swiper_button_prev gradient-btn ",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), Categories_objectSpread(Categories_objectSpread({}, arrow_big/* default */.Z), {}, {
                    alt: ""
                  }))
                })]
              })
            })]
          })]
        }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [!(query !== null && query !== void 0 && query.country) && /*#__PURE__*/(0,jsx_runtime.jsx)(filters, {
            data: items,
            rawData: data === null || data === void 0 ? void 0 : data.items,
            setData: setItems
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            ref: projectsTopRef,
            className: "projects-page-wrapper",
            children: isPageLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "d-flex justify-content-center align-items-center",
              style: {
                minHeight: "400px"
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "spinner-border text-primary",
                role: "status",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "visually-hidden",
                  children: "Loading..."
                })
              })
            }) : renderProjectItems
          }), slidingbuttons]
        }), expandedImage && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "zoom-image",
          onClick: function onClick() {
            return setExpandedImage("");
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: expandedImage,
            width: 1200,
            height: 1200,
            alt: ""
          })
        }), isRequestOpen && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "request-modal",
          onClick: function onClick() {
            return setIsRequestOpen(false);
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "request-modal-content",
            onClick: function onClick(event) {
              return event.stopPropagation();
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "request-modal-header",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedMessage, {
                  id: "recruitmentRequest"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                type: "button",
                className: "request-modal-close",
                onClick: function onClick() {
                  return setIsRequestOpen(false);
                },
                "aria-label": "close",
                children: "\xD7"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(RequestForm["default"], {
              countries: data ? [data] : [],
              person: selectedPerson,
              onSuccess: function onSuccess() {
                return setIsRequestOpen(false);
              }
            })]
          })
        })]
      })
    })
  });
}

/***/ }),

/***/ 5467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(682);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6896);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);







var BreadCrumb = function BreadCrumb(_ref) {
  var _heading$locale, _description$locale;

  var heading = _ref.heading,
      _ref$description = _ref.description,
      description = _ref$description === void 0 ? "" : _ref$description;

  var _useIntl = (0,react_intl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(),
      locale = _useIntl.locale;

  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)(),
      pathname = _useRouter.pathname;

  var shouldHidePath = pathname.startsWith("/blogs/") && pathname !== "/blogs";
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
    className: "breads wrapper",
    style: {
      backgroundColor: "rgb(112 96 166 / 100%)"
    },
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: "inner",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("h1", {
          className: "unique-bold h3",
          children: (_heading$locale = heading === null || heading === void 0 ? void 0 : heading[locale]) !== null && _heading$locale !== void 0 ? _heading$locale : heading
        }), ((description === null || description === void 0 ? void 0 : description[locale]) || (description === null || description === void 0 ? void 0 : description.length) > 0) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("ul", {
          children: !shouldHidePath && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("li", {
            children: (_description$locale = description === null || description === void 0 ? void 0 : description[locale]) !== null && _description$locale !== void 0 ? _description$locale : description
          })
        })]
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (BreadCrumb);

/***/ }),

/***/ 6543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2962);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _src_components_helpers_seo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(540);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);





var Seo = function Seo(_ref) {
  var title = _ref.title,
      description = _ref.description,
      keywords = _ref.keywords,
      _ref$noindex = _ref.noindex,
      noindex = _ref$noindex === void 0 ? false : _ref$noindex;

  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)(),
      asPath = _useRouter.asPath,
      locale = _useRouter.locale;

  var _buildSeoAlternates = (0,_src_components_helpers_seo__WEBPACK_IMPORTED_MODULE_3__/* .buildSeoAlternates */ .Rl)(asPath, locale),
      canonical = _buildSeoAlternates.canonical,
      languageAlternates = _buildSeoAlternates.languageAlternates;

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_0__/* .NextSeo */ .PB, {
    title: title,
    description: description,
    defaultTitle: title,
    noindex: noindex,
    nofollow: noindex,
    canonical: canonical,
    languageAlternates: languageAlternates,
    additionalMetaTags: [{
      name: "keywords",
      content: keywords
    }]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (Seo);

/***/ }),

/***/ 4266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var _home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(29);
/* harmony import */ var _home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7794);
/* harmony import */ var _home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7536);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6896);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(4012);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1608);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1555);
/* harmony import */ var _src_api_server__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5981);
/* harmony import */ var sweetalert2__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6455);
/* harmony import */ var sweetalert2__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(sweetalert2__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5893);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













var RequestForm = function RequestForm(_ref) {
  var _errors$name, _errors$phone, _errors$email, _errors$message;

  var person = _ref.person,
      onSuccess = _ref.onSuccess;

  var _useIntl = (0,react_intl__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(),
      formatMessage = _useIntl.formatMessage,
      locale = _useIntl.locale;

  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)(),
      query = _useRouter.query;

  var _useForm = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_8__/* .useForm */ .cI)(),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      reset = _useForm.reset,
      errors = _useForm.formState.errors;

  var getLocalizedValue = function getLocalizedValue(field, locale) {
    var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "-";

    if (typeof field === "object" && field !== null) {
      var _field$ar, _field$ar$trim, _field$en, _field$en$trim, _field$locale, _field$locale$trim;

      var ar = field === null || field === void 0 ? void 0 : (_field$ar = field.ar) === null || _field$ar === void 0 ? void 0 : (_field$ar$trim = _field$ar.trim) === null || _field$ar$trim === void 0 ? void 0 : _field$ar$trim.call(_field$ar);
      var en = field === null || field === void 0 ? void 0 : (_field$en = field.en) === null || _field$en === void 0 ? void 0 : (_field$en$trim = _field$en.trim) === null || _field$en$trim === void 0 ? void 0 : _field$en$trim.call(_field$en);
      if (!ar && !en) return fallback;
      var localized = field === null || field === void 0 ? void 0 : (_field$locale = field[locale]) === null || _field$locale === void 0 ? void 0 : (_field$locale$trim = _field$locale.trim) === null || _field$locale$trim === void 0 ? void 0 : _field$locale$trim.call(_field$locale);
      return localized || ar || en || fallback;
    }

    if (typeof field === "string") {
      return field.trim() || fallback;
    }

    return fallback;
  };

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    var _person$name, _person$country, _person$name2, _person$name2$experie;

    if (query !== null && query !== void 0 && query.personId) reset({
      message: "\u0645\u0647\u062A\u0645 \u0628\u0627\u0644\u0633\u064A\u0631\u0629 \u0627\u0644\u0630\u0627\u062A\u064A\u0629 \u0643\u0648\u062F ".concat(query === null || query === void 0 ? void 0 : query.personId, " \u0648\u0627\u0644\u0627\u0633\u0645 ").concat(query === null || query === void 0 ? void 0 : query.name)
    });else reset({
      message: "\u0627\u0644\u0627\u0633\u0645: ".concat((person === null || person === void 0 ? void 0 : (_person$name = person.name) === null || _person$name === void 0 ? void 0 : _person$name.ar) || "", "\n        \n\u0627\u0644\u062F\u064A\u0627\u0646\u0629: ").concat(getLocalizedValue(person === null || person === void 0 ? void 0 : person.religion, locale) || "", "\n    \n\u0627\u0644\u0643\u0648\u062F: ").concat((person === null || person === void 0 ? void 0 : person.id) || "", "\n\n\u0627\u0644\u062F\u0648\u0644\u0629: ").concat(getLocalizedValue(person === null || person === void 0 ? void 0 : (_person$country = person.country) === null || _person$country === void 0 ? void 0 : _person$country.name, locale) || "", "\n \n\u0627\u0644\u0639\u0645\u0631: ").concat((person === null || person === void 0 ? void 0 : person.age) || "", "\n\n\u0627\u0644\u0644\u063A\u0629: ").concat(getLocalizedValue(person === null || person === void 0 ? void 0 : person.experience, locale) || "", "\n\n\u0633\u0646\u0648\u0627\u062A \u0627\u0644\u062E\u0628\u0631\u0629: ").concat((person === null || person === void 0 ? void 0 : (_person$name2 = person.name) === null || _person$name2 === void 0 ? void 0 : (_person$name2$experie = _person$name2.experienceYears) === null || _person$name2$experie === void 0 ? void 0 : _person$name2$experie.toString().trim()) || "", "\n\n\u0631\u0633\u0648\u0645 \u0627\u0644\u0627\u0633\u062A\u0642\u062F\u0627\u0645: ").concat((person === null || person === void 0 ? void 0 : person.recruitmentFees) || "", "\n        \n        ")
    });
  }, [query === null || query === void 0 ? void 0 : query.personId, query === null || query === void 0 ? void 0 : query.name, person, reset, locale]);

  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = (0,_home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee(data) {
      return _home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              data.personnel = query === null || query === void 0 ? void 0 : query.personId;
              _context.next = 4;
              return _src_api_server__WEBPACK_IMPORTED_MODULE_3__/* ["default"].post */ .Z.post("/requests", data);

            case 4:
              reset();
              onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
              sweetalert2__WEBPACK_IMPORTED_MODULE_4___default().fire("".concat(formatMessage({
                id: "thanks"
              })), "".concat(formatMessage({
                id: "thankMsg"
              })), "success");
              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              console.log("error", _context.t0);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 9]]);
    }));

    return function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      className: "order-form",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("form", {
        onSubmit: handleSubmit(onSubmit),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
            xs: "12",
            md: "6",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
              className: "form-group",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("label", {
                htmlFor: "name",
                children: formatMessage({
                  id: "name"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("input", _objectSpread({
                id: "name",
                className: "form-control"
              }, register("name", {
                required: true
              }))), (errors === null || errors === void 0 ? void 0 : (_errors$name = errors.name) === null || _errors$name === void 0 ? void 0 : _errors$name.type) === "required" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
                className: "error-hint",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                  id: "required"
                })
              })]
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
            xs: "12",
            md: "6",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
              className: "form-group",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("label", {
                htmlFor: "phone",
                children: formatMessage({
                  id: "phone"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("input", _objectSpread(_objectSpread({
                id: "phone",
                className: "form-control"
              }, register("phone", {
                required: true
              })), {}, {
                maxLength: 14,
                type: "text",
                onKeyPress: function onKeyPress(event) {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }
              })), (errors === null || errors === void 0 ? void 0 : (_errors$phone = errors.phone) === null || _errors$phone === void 0 ? void 0 : _errors$phone.type) === "required" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
                className: "error-hint",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                  id: "required"
                })
              })]
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
            xs: "12",
            md: "12",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
              className: "form-group",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("label", {
                htmlFor: "email",
                children: formatMessage({
                  id: "email"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("input", _objectSpread({
                id: "email",
                type: "email",
                className: "form-control"
              }, register("email", {
                required: true
              }))), (errors === null || errors === void 0 ? void 0 : (_errors$email = errors.email) === null || _errors$email === void 0 ? void 0 : _errors$email.type) === "required" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
                className: "error-hint",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                  id: "required"
                })
              })]
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
            xs: "12",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
              className: "form-group",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("label", {
                htmlFor: "details",
                children: formatMessage({
                  id: "details"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("textarea", _objectSpread(_objectSpread({
                id: "details",
                className: "form-control"
              }, register("message", {
                required: true
              })), {}, {
                rows: "7" // placeholder={formatMessage({
                //   id: "details",
                // })}

              })), (errors === null || errors === void 0 ? void 0 : (_errors$message = errors.message) === null || _errors$message === void 0 ? void 0 : _errors$message.type) === "required" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
                className: "error-hint",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                  id: "required"
                })
              })]
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
            xs: "12",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
              className: "form-group button",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("button", {
                type: "submit",
                className: "btn gradient-btn",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                  id: "send"
                })
              })
            })
          })]
        })
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (RequestForm);

/***/ }),

/***/ 9400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* binding */ handleImage; }
});

;// CONCATENATED MODULE: ./src/assets/images/placeholder.jpg
/* harmony default export */ var placeholder = ({"src":"/_next/static/media/placeholder.75cf2fc2.jpg","height":319,"width":474,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAUACAMBIgACEQEDEQH/xAAnAAEBAAAAAAAAAAAAAAAAAAAABwEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAAAsgP/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/9oACAEBAAE/AH//xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oACAECAQE/AH//xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oACAEDAQE/AH//2Q==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/components/handlers/index.js

var handleImage = function handleImage(image) {
  var _ref;

  if ((_ref = "".concat(image)) !== null && _ref !== void 0 && _ref.includes("http")) return image;

  if (image) {
    if (!image.startsWith("/")) image = "/".concat(image);
    return "".concat("https://alnojoom.ejjadh.info/").concat(image);
  }

  return image || (placeholder === null || placeholder === void 0 ? void 0 : placeholder.src);
};

/***/ }),

/***/ 7819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Iz": function() { return /* binding */ handleImageLink; },
/* harmony export */   "SI": function() { return /* binding */ htmlToExcerpt; },
/* harmony export */   "zv": function() { return /* binding */ getId; }
/* harmony export */ });
/* unused harmony exports mapBlogForListing, checkRedirect */
/* harmony import */ var _home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7794);
/* harmony import */ var _home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);



var getId = function getId(obj) {
  return (obj === null || obj === void 0 ? void 0 : obj._id) || (obj === null || obj === void 0 ? void 0 : obj.id) || "".concat(obj);
}; // يبني مُقتطف نصي قصير من HTML كامل (يحذف الصور base64 والوسوم) لتفادي تضخيم حجم الصفحة

var htmlToExcerpt = function htmlToExcerpt(html) {
  var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  if (!html) return "";
  var withoutImages = String(html).replace(/<img[^>]*>/gi, "");
  var text = withoutImages.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
  return text.length > maxLength ? "".concat(text.slice(0, maxLength).trim(), "\u2026") : text;
}; // يحوّل قيمة مترجمة (ar/en) تحتوي HTML كامل إلى نفس الشكل لكن بمقتطف نصي قصير

var localizedExcerpt = function localizedExcerpt(localized, maxLength) {
  if (!localized || typeof localized !== "object") return localized;
  return Object.fromEntries(Object.entries(localized).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        locale = _ref2[0],
        html = _ref2[1];

    return [locale, htmlToExcerpt(html, maxLength)];
  }));
}; // يبني نسخة خفيفة من كائن المدونة لصفحات القوائم، بدون وصف HTML الكامل
// (الذي قد يحتوي صورًا مرفوعة كـ base64 ويُضاعف حجم الصفحة عند تسلسله ضمن __NEXT_DATA__)


var mapBlogForListing = function mapBlogForListing(blog) {
  var _blog$category, _blog$category2, _blog$category3;

  var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  return {
    id: (blog === null || blog === void 0 ? void 0 : blog.id) || (blog === null || blog === void 0 ? void 0 : blog._id) || null,
    title: blog === null || blog === void 0 ? void 0 : blog.title,
    image: blog === null || blog === void 0 ? void 0 : blog.image,
    category: blog !== null && blog !== void 0 && blog.category ? {
      id: (blog === null || blog === void 0 ? void 0 : (_blog$category = blog.category) === null || _blog$category === void 0 ? void 0 : _blog$category.id) || (blog === null || blog === void 0 ? void 0 : (_blog$category2 = blog.category) === null || _blog$category2 === void 0 ? void 0 : _blog$category2._id) || null,
      title: (blog === null || blog === void 0 ? void 0 : (_blog$category3 = blog.category) === null || _blog$category3 === void 0 ? void 0 : _blog$category3.title) || null
    } : null,
    createdAt: blog === null || blog === void 0 ? void 0 : blog.createdAt,
    description: localizedExcerpt(blog === null || blog === void 0 ? void 0 : blog.description, maxLength)
  };
};
var handleImageLink = function handleImageLink(image) {
  if (image !== null && image !== void 0 && image.includes("http")) {
    return image;
  } else {
    return "".concat("https://alnojoom.ejjadh.info/", "/").concat(image);
  }
}; // ضع هذا الكود داخل نفس ملف الصفحة

var REDIRECTS_ENDPOINT = "https://alnojoom.ejjadh.info/api/seoRedirects"; // نظّف المسار: فك التشفير + إزالة ?query + إزالة / آخر المسار

function cleanPath() {
  var resolvedUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

  try {
    var noQuery = String(resolvedUrl).split("?")[0] || "/";
    var decoded = decodeURI(noQuery);
    return decoded.length > 1 && decoded.endsWith("/") ? decoded.slice(0, -1) : decoded;
  } catch (_unused) {
    var _noQuery = String(resolvedUrl).split("?")[0] || "/";

    return _noQuery.length > 1 && _noQuery.endsWith("/") ? _noQuery.slice(0, -1) : _noQuery;
  }
} // ابنِ Destination مطلق بدون أي Query Params


function toAbsoluteNoQuery(destRaw, req) {
  try {
    if (/^https?:\/\//i.test(destRaw)) {
      var u = new URL(destRaw);
      u.search = "";
      return u.toString();
    }

    var protocol = (req.headers["x-forwarded-proto"] || "").split(",")[0] || (req.socket && req.socket.encrypted ? "https" : "http");
    var host = req.headers.host;
    var path = destRaw.startsWith("/") ? destRaw : "/".concat(destRaw);
    return "".concat(protocol, "://").concat(host).concat(path);
  } catch (_unused2) {
    return String(destRaw).split("?")[0];
  }
}

function checkRedirect(_x, _x2) {
  return _checkRedirect.apply(this, arguments);
}

function _checkRedirect() {
  _checkRedirect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolvedUrl, req) {
    var path, res, json, redirects, hit, permanent;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            path = cleanPath(resolvedUrl);
            _context.prev = 1;
            _context.next = 4;
            return fetch(REDIRECTS_ENDPOINT, {
              headers: {
                Accept: "application/json"
              }
            });

          case 4:
            res = _context.sent;

            if (res.ok) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return", null);

          case 7:
            _context.next = 9;
            return res.json();

          case 9:
            json = _context.sent;
            redirects = json && json.data && json.data.seoRedirects || [];
            hit = redirects.find(function (r) {
              return (r === null || r === void 0 ? void 0 : r.source) && (r === null || r === void 0 ? void 0 : r.destination) && cleanPath(r.source) === path;
            });

            if (hit) {
              _context.next = 14;
              break;
            }

            return _context.abrupt("return", null);

          case 14:
            permanent = String(hit.redirectCode) === "301" || String(hit.redirectCode) === "308";
            return _context.abrupt("return", {
              destination: toAbsoluteNoQuery(String(hit.destination).trim(), req),
              permanent: permanent
            });

          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", null);

          case 21:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 18]]);
  }));
  return _checkRedirect.apply(this, arguments);
}

/***/ }),

/***/ 540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rl": function() { return /* binding */ buildSeoAlternates; }
/* harmony export */ });
/* unused harmony exports SITE_URL, DEFAULT_LOCALE, localizedUrl */
// ====== إعدادات الـ SEO المشتركة ======
var SITE_URL = "https://alnjoom.sa";
var DEFAULT_LOCALE = "ar"; // النسخة الافتراضية (x-default) هي العربية
// ينظّف الـ path: يشيل الـ query/hash ويضبط الـ trailing slash

var normalizePath = function normalizePath() {
  var asPath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var path = String(asPath).split("?")[0].split("#")[0] || "/";
  if (!path.startsWith("/")) path = "/".concat(path); // مطابقة لإعداد trailingSlash: true في next.config.js

  if (path !== "/" && !path.endsWith("/")) path = "".concat(path, "/");
  return path;
}; // يبني رابط مطلق للّغة المطلوبة (العربية بدون بادئة، الإنجليزية ببادئة /en)


var localizedUrl = function localizedUrl(asPath, locale) {
  var path = normalizePath(asPath); // يبدأ بـ "/" وينتهي بـ "/"

  if (locale === DEFAULT_LOCALE) return "".concat(SITE_URL).concat(path);
  return path === "/" ? "".concat(SITE_URL, "/").concat(locale, "/") : "".concat(SITE_URL, "/").concat(locale).concat(path);
}; // يبني canonical + hreflang (ar / en / x-default) لأي صفحة
// x-default يشير دائمًا للنسخة العربية

var buildSeoAlternates = function buildSeoAlternates(asPath) {
  var currentLocale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_LOCALE;
  return {
    canonical: localizedUrl(asPath, currentLocale),
    languageAlternates: [{
      hrefLang: "ar",
      href: localizedUrl(asPath, "ar")
    }, {
      hrefLang: "en",
      href: localizedUrl(asPath, "en")
    }, {
      hrefLang: "x-default",
      href: localizedUrl(asPath, DEFAULT_LOCALE)
    }]
  };
};

/***/ }),

/***/ 9492:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/arrow-big.e723219e.svg","height":16,"width":18});

/***/ }),

/***/ 1476:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/download.b3e7badf.svg","height":20,"width":20});

/***/ }),

/***/ 7571:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/expand.83306eef.svg","height":16,"width":16});

/***/ }),

/***/ 5175:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/sar.f03e266e.svg","height":13,"width":12});

/***/ }),

/***/ 6063:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"projects":"Categories_projects__Hg4i8","project_item":"Categories_project_item__nvyid","gradient_in":"Categories_gradient_in__PTwW0","gradient_out":"Categories_gradient_out___OhMe","gradient_opacity_out":"Categories_gradient_opacity_out__1siJp","gradient_opacity_in":"Categories_gradient_opacity_in__Fb5zJ"};

/***/ }),

/***/ 6154:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"singleProjectBody":"projects_singleProjectBody__uWgzA","projectsPage":"projects_projectsPage__KcKLX","gradient_in":"projects_gradient_in__qfyMX","gradient_out":"projects_gradient_out___jDot","gradient_opacity_out":"projects_gradient_opacity_out__ZfHDe","gradient_opacity_in":"projects_gradient_opacity_in__cs9x8"};

/***/ }),

/***/ 3414:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 172:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 2001:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 3779:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 2258:
/***/ (function() {

/* (ignored) */

/***/ })

}]);